<template>
  <div class="base-wrap clearfix">
    <div class="line" style="width: 100%; display: flex;" >
      <div style="flex: 1; margin-right: 24px;">
        <div class="line-item" style="margin-right: 0px">
          <div class="label">
            <span class="red">*</span>Name
          </div>
          <el-input id="name" class="base-input" v-model="name"></el-input>
        </div>
      </div>
      <div style="flex: 1; margin-right: 24px;">
        <div class="line-item" style="margin-right: 0px">
          <div class="label">
            <span class="red">*</span>Telephone
          </div>
          <div style="display: flex">
            <el-select class="base-input" style="width: 85px; margin-right: 10px" v-model="telTypeValue" placeholder="请选择区号">
              <el-option
                v-for="item in telType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input
              style="width: 210px"
              type="tel"
              :maxlength="15"
              id="telephone"
              class="base-input"
              v-model="telephone"
            ></el-input>
          </div>
        </div>
      </div>
      <div style="flex: 1; margin-right: 24px;">
        <div class="line-item" style="margin-right: 0px">
          <div class="label">
            <span class="red">*</span>Email
          </div>
          <el-input id="email" class="base-input" v-model="email"></el-input>
        </div>
      </div>
      <div style="flex: 1; margin-right: 0px;">
        <div class="line-item" style="margin-right: 0px">
          <div class="label">
            <span class="red">*</span>Residential Address
          </div>
          <el-input
            type="text"
            id="residentialAddress"
            class="base-input"
            v-model="residentialAddress"
          ></el-input>
        </div>
      </div>
      <!--<el-col :span="6">
        <div class="line-item">
          <div class="label">
            <span class="red">*</span>性别
          </div>
          <el-select id="sex" class="base-input" v-model="sex" placeholder="请选择性别">
            <el-option
              v-for="item in sexes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="line-item">
          <div class="label">
            <span class="red">*</span>出生年月
          </div>
          <el-date-picker
            :default-value="new Date('1999-01-01')"
            id="birthday"
            class="base-input"
            v-model="birthday"
            type="date"
            placeholder="请选择出生年月"
          ></el-date-picker>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="line-item">
          <div class="label">
            <span class="red">*</span>籍贯
          </div>
          <el-select
            class="base-input"
            filterable
            clearable
            remote
            placeholder="请输入搜索条件"
            reserve-keyword
            :remote-method="remoteMethod"
            :loading="loading"
            @focus="handleNativePlaceFocus"
            @blur="handleNativePlaceBlur"
            v-model="nativePlace"
          >
            <el-option
              :key="item.id"
              :label="item.label"
              :value="item.value"
              v-for="item in placeList"
            ></el-option>
          </el-select>
        </div>
      </el-col>-->
    </div>
    <!--<div class="line">
      <el-col :span="6">
        <div class="line-item">
          <div class="label">
            <span class="red">*</span>联系电话
          </div>
          <el-input
            type="number"
            :maxlength="11"
            id="telephone"
            class="base-input"
            v-model="telephone"
          ></el-input>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="line-item">
          <div class="label">
            <span class="red">*</span>电子邮箱
          </div>
          <el-input id="email" class="base-input" v-model="email"></el-input>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="line-item">
          <div class="label">
            <span class="red">*</span>到岗时间
          </div>
          <el-date-picker
            id="arrivalTime"
            class="base-input"
            v-model="arrivalTime"
            type="date"
            placeholder="请选择到岗时间"
          ></el-date-picker>
        </div>
      </el-col>
      &lt;!&ndash; <el-col :span="6">
        <div class="line-item">
          <div class="label"><span class="red">*</span>紧急联系人</div>
          <el-input id="emergencyPerson" class="base-input" v-model="emergencyPerson"></el-input>
        </div>
      </el-col>&ndash;&gt;
    </div>-->
    <!--<div class="line">
      &lt;!&ndash; <el-col :span="6">
        <div class="line-item">
          <div class="label"><span class="red">*</span>紧急联系方式</div>
          <el-input type="number" :maxlength="11" id="emergencyNumber" class="base-input" v-model="emergencyNumber"></el-input>
        </div>
      </el-col>&ndash;&gt;
    </div>-->
  </div>
</template>

<script>
import { getNativePlaceList } from "../../api/search";
export default {
  data() {
    return {
      name: "",
      sex: "",
      birthday: "",
      nativePlace: "",
      arrivalTime: "",
      major: "",
      telephone: "",
      residentialAddress: '',
      email: "",
      QWNumber: "",
      emergencyPerson: "",
      emergencyNumber: "",
      department: "",
      signThird: "",
      schoolAwards: "",
      placeList: [],
      loading: false,
      placeholder: "请填写籍贯",
      sexes: [
        {
          value: "男",
          label: "男"
        },
        {
          value: "女",
          label: "女"
        }
      ],
      telType: [
        {
          value: "+65",
          label: "+65"
        },
        {
          value: "+60",
          label: "+60"
        },
        {
          value: "+86",
          label: "+86"
        },
        {
          value: "+1",
          label: "+1"
        },
        {
          value: "+91",
          label: "+91"
        },
        {
          value: "+95",
          label: "+95"
        },
        {
          value: "+66",
          label: "+66"
        },
        {
          value: "+62",
          label: "+62"
        },
        {
          value: "+852",
          label: "+852"
        },
        {
          value: "+853",
          label: "+853"
        },
        {
          value: "+886",
          label: "+886"
        }
      ],
      telTypeValue: '+65',
      signThirdParty: [
        {
          value: "是",
          label: "是"
        },
        {
          value: "否",
          label: "否"
        }
      ]
    };
  },
  methods: {
    remoteMethod(query) {
      console.log(query);
      if (query !== "") {
        this.loading = true;
        getNativePlaceList(query).then(res => {
          this.loading = false;
          if (res.code === "10000") {
            this.placeList = res.data.map(it => {
              it = { ...it, label: it.name, value: it.name, id: Math.random() };
              return it;
            });
          }
        });
      } else {
        this.placeList = [];
      }
    },
    //修改手机号码
    changePhone(val){
      this.telephone = val
    },
    handleNativePlaceFocus() {
      if (!this.nativePlace) {
        this.placeholder = "请输入搜索条件";
      }
    },
    handleNativePlaceBlur() {
      if (this.placeholder === "请输入搜索条件") {
        this.placeholder = "请填写籍贯";
      }
    }
  }
};
</script>

<style lang="stylus">
.base-wrap {
  margin-top: 24px;
  margin-bottom: 30px;
  width: calc(100% - 140px);

  .line {
    .line-item {
      margin-top: 24px;
      margin-right: 16px;
      text-align: right;

      .label {
        .red {
          font-size: 10px;
          color: #f03b3b;
        }

        font-size: 14px;
        text-align: left;
      }

      .base-input {
        width: 100%;
        display: inline-block;
      }

      .bottom-input {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base-info/base-info.vue